import FilterListIcon from "@mui/icons-material/FilterList";
import MoneyOffIcon from "@mui/icons-material/MoneyOff";
import {
  Box,
  Button,
  FormControlLabel,
  IconButton,
  Menu,
  OutlinedInput,
  Radio,
  RadioGroup,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import React, { useState } from "react";

const HeaderSearch = ({
  handleEnterPressionar,
  handleChangePesquisa,
  handlePesquisa,
  verificaPendenciasAll,
  handleRadio,
  handleRadioBloqueio,
  handleRadioidExterno,
  listar,
  listarBloqueio,
  listaridExterno,
}) => {
  const theme = useTheme();
  const isTablet = useMediaQuery(theme.breakpoints.down("md"));
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleOpenMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  return (
    <Box p={3}>
      <Box
        display="flex"
        flexDirection={isMobile ? "column" : "row"}
        flexWrap="wrap"
        gap={2}
        alignItems="center"
      >
        <Box flex={1} minWidth={isMobile ? "100%" : 230}>
          <OutlinedInput
            placeholder="Nome da empresa"
            fullWidth
            name="pesquisa"
            variant="outlined"
            onKeyPress={handleEnterPressionar}
            onChange={handleChangePesquisa}
          />
        </Box>

        <Box height="3.5rem" minWidth={isMobile ? "100%" : "0"}>
          {isTablet && !isMobile ? (
            <IconButton color="primary" onClick={handleOpenMenu}>
              <FilterListIcon />
            </IconButton>
          ) : (
            <Button
              variant="outlined"
              fullWidth={isMobile}
              sx={{ height: "100%" }}
              color="primary"
              onClick={handleOpenMenu}
              startIcon={<FilterListIcon />}
            >
              Filtros
            </Button>
          )}
          <Menu anchorEl={anchorEl} open={open} onClose={handleCloseMenu}>
            <Box padding="1.5rem">
              <Typography variant="subtitle2">Status</Typography>
              <RadioGroup
                row
                onChange={handleRadio}
                name="ativar"
                value={listar}
              >
                <FormControlLabel
                  value="todos"
                  control={<Radio />}
                  label="Todos"
                />
                <FormControlLabel
                  value="ativos"
                  control={<Radio />}
                  label="Ativo"
                />
                <FormControlLabel
                  value="inativos"
                  control={<Radio />}
                  label="Inativo"
                />
              </RadioGroup>
              <Box my="1rem">
                <Typography variant="subtitle2">Data de Bloqueio</Typography>
                <RadioGroup
                  row
                  onChange={handleRadioBloqueio}
                  name="dataBloqueio"
                  value={listarBloqueio}
                >
                  <FormControlLabel
                    value="todosDtBloqueio"
                    control={<Radio />}
                    label="Todos"
                  />
                  <FormControlLabel
                    value="comDtBloqueio"
                    control={<Radio />}
                    label="Com data de bloqueio"
                  />
                  <FormControlLabel
                    value="semDtBloqueio"
                    control={<Radio />}
                    label="Sem data de bloqueio"
                  />
                </RadioGroup>
              </Box>

              <Typography variant="subtitle2">ID Externo</Typography>
              <RadioGroup
                row
                onChange={handleRadioidExterno}
                name="idExterno"
                value={listaridExterno}
              >
                <FormControlLabel
                  value="todosIdExterno"
                  control={<Radio />}
                  label="Todos"
                />
                <FormControlLabel
                  value="comIdExterno"
                  control={<Radio />}
                  label="Com ID Externo"
                />
                <FormControlLabel
                  value="semIdExterno"
                  control={<Radio />}
                  label="Sem ID Externo"
                />
              </RadioGroup>
            </Box>
          </Menu>
        </Box>

        <Box height="3.5rem" minWidth={isMobile ? "100%" : 100}>
          <Button
            variant="contained"
            color="primary"
            onClick={handlePesquisa}
            fullWidth
            sx={{ height: "100%" }}
          >
            Buscar
          </Button>
        </Box>

        <Box
          minWidth={isTablet ? "100%" : 180}
          height="3.5rem"
          alignSelf={isMobile ? "flex-end" : "center"}
        >
          <Button
            variant="contained"
            color="secondary"
            sx={{ height: "100%" }}
            onClick={verificaPendenciasAll}
            fullWidth
            startIcon={<MoneyOffIcon />}
          >
            Verificar boletos vencidos
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default HeaderSearch;
